module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAwElEQVQ4jb2UMQ6CQBBFHwS2NGE7GkJBwaGkIrZ0XkKvoBUHsbH0AJpQiI0dJDbGpbERszEkyAq+cpJ5838z1m5/EMAamAOSYdRADiwdYCW9WRZHIUK4gyxKNd6xOGdVfbvbQGIiARDCJY5CgIUNSBOJLgOkbWz4oFfkByl+kP4u+pbRRE7XsKuKPrtetn9OpF9sk3SlmCTRtNV0+iq1jFqtUqoxFrx2KxvIT0WJieyhFKeiBNhY2mNLAG+g6/3YnjxBOOB7dekAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dash-btn2.png
// module id = W1LU
// module chunks = 1